import { Profile } from './profile.interface';

export interface SignupRequest extends Omit<Profile, 'userId'> {
  password: string;
}

export interface CompanyDetails {
  orgName: string;
  numOfEmp: string;
  industry?: string;
  firstName: string;
  lastName: string;
  country: string;
  phoneNumber: string;
  email?: string;
  password?: string;
  phoneCode?: string;
}

export interface IndustryOption {
  label: string;
}

export const INDUSTRY_OPTIONS: IndustryOption[] = [
  { label: 'Accounting' },
  { label: 'Advertising & Marketing' },
  { label: 'Aerospace & Defence' },
  { label: 'Agriculture' },
  { label: 'Architecture & Design' },
  { label: 'Automotive' },
  { label: 'Aviation' },
  { label: 'Banking' },
  { label: 'Biotechnology' },
  { label: 'Building & Construction' },
  { label: 'Business Services' },
  { label: 'Chemicals' },
  { label: 'Cleaning Services' },
  { label: 'Consulting' },
  { label: 'Consumer Goods' },
  { label: 'Cybersecurity' },
  { label: 'Defence' },
  { label: 'Education' },
  { label: 'Electrical Services' },
  { label: 'Electronics' },
  { label: 'Energy' },
  { label: 'Engineering' },
  { label: 'Entertainment' },
  { label: 'Environmental Services' },
  { label: 'Facilities Management' },
  { label: 'Financial Services' },
  { label: 'Food & Beverage' },
  { label: 'Forestry' },
  { label: 'Freight & Logistics' },
  { label: 'Government' },
  { label: 'Healthcare' },
  { label: 'Hospitality' },
  { label: 'Human Resources' },
  { label: 'Information Technology' },
  { label: 'Insurance' },
  { label: 'Legal Services' },
  { label: 'Manufacturing' },
  { label: 'Media' },
  { label: 'Mining & Resources' },
  { label: 'Not-for-Profit' },
  { label: 'Oil & Gas' },
  { label: 'Pharmaceuticals' },
  { label: 'Professional Services' },
  { label: 'Property & Real Estate' },
  { label: 'Public Services' },
  { label: 'Recruitment' },
  { label: 'Renewable Energy' },
  { label: 'Research' },
  { label: 'Retail' },
  { label: 'Security Services' },
  { label: 'Software & SaaS' },
  { label: 'Telecommunications' },
  { label: 'Tourism & Travel' },
  { label: 'Transport' },
  { label: 'Utilities' },
  { label: 'Warehousing & Distribution' },
  { label: 'Wholesale' },
  { label: 'Other' },
];

export interface InvitationDetails {
  orgName: string;
  numOfEmp: string;
  email?: string;
  userId?: string;
  orgId?: string;
  onboardingStatus?: boolean;
  hostFirstName?: string;
  hostLastName?: string;
}

export interface CompanySize {
  title: string;
  val: string;
}

export const COMPANY_SIZE: CompanySize[] = [
  {
    title: '2 - 25',
    val: '2-25',
  },
  {
    title: '26 - 100',
    val: '26-100',
  },
  {
    title: '101 - 250',
    val: '101-250',
  },
  {
    title: '251 - 1000',
    val: '251 - 1000',
  },
  {
    title: '1000+',
    val: '1000+',
  },
  {
    title: `it's Just me!`,
    val: '1',
  },
];
